import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Events/GlobalFreightSummit/components/SectionDescription/SectionDescription.module.scss';

const cn = classNames.bind(styles);

const SectionDescription = (): ReactElement => {
  return (
    <section className={cn('description')}>
      <div className={cn('container')}>
        <h3 className={cn('description__title')}>description</h3>
        <div className={cn('description__content')}>
          <div className={cn('description__content-box')}>
            <div className={cn('description__paragraphs-box')}>
              <p className={cn('description__paragraphs-text')}>
                Since the inaugural summit in 2022, The Global Freight Summit, hosted by DP World,
                brings together international freight forwarding, trade alliances and supply chain
                communities to offer unparalleled networking opportunities, interactive sessions,
                fireside discussions and keynote speeches from some of the brightest minds in the industry.
              </p>
              <p className={cn('description__paragraphs-text')}>
                The third edition, scheduled for 18-20 November 2024 in Dubai, will focus on actionable
                strategies under the theme "Acting today to reach the opportunities of tomorrow”.
                This will be explored through key topics such as; winning in the race to digitalisation,
                grasping the opportunity of sustainability, remaining agile and building more resilient
                trade routes and capitalising on opportunities in a global market.
              </p>
            </div>
          </div>
          <div className={cn('description__content-box')}>
            <div className={cn('description__paragraphs-box')}>
              <p className={cn('description__paragraphs-text')}>
                Leading these topics will be a range of world-class speakers who will provide
                thought-provoking and inspiring discussions, to debate and tackle the best routes
                forward to create resilient supply chains for both now and in the future. Join your
                colleagues, peers and partners at The Global Freight Summit 2024 for a packed agenda
                of meaningful conversation, networking and business development opportunities.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionDescription;